<div class="ltms-description">{{ mainDiscription }}</div>
<div class="action-summary-main-container">
    <div class="action-summary-left-container">
        <div>
            <app-action-summary-overall [totalResponses]="totalResponses" [totalActionableResponses]="totalActionableResponses"></app-action-summary-overall>
        </div>
        <div>
            <app-action-summary-hierarchy [overallData]="overallData" [componentId]="overallData.elementId" (onDrilldownChange)="onDrilldownChange($event)"></app-action-summary-hierarchy>
        </div>
    </div>
    <div class="action-summary-right-container">
        <!-- <div>
            <app-action-summary-trend-chart [filters]="filters" [componentId]="histogramChartId"></app-action-summary-trend-chart>
        </div> -->
        <div>
            <app-action-summary-bar-chart [filters]="filters" [componentId]="categoryChartId"></app-action-summary-bar-chart>
        </div>
    </div>
</div>
